<template>
  <div v-if="visible" class="fixed bottom-0 left-0 right-0 bg-gray-900 text-white z-50 shadow-lg">
    <div class="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div class="flex-1">
        <p class="text-sm">{{ t('cookies.message') }}</p>
        <a href="/cookie-policy" class="text-xs text-blue-300 hover:underline">{{ t('cookies.learn_more') }}</a>
      </div>
      <div class="flex gap-2 shrink-0">
        <button @click="acceptAll" class="px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition">
          {{ t('cookies.accept_all') }}
        </button>
        <button @click="acceptEssential" class="px-4 py-2 text-sm font-medium bg-gray-700 text-gray-200 rounded-lg hover:bg-gray-600 transition">
          {{ t('cookies.essential_only') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const visible = ref(false)

onMounted(() => {
  if (!getCookie('cookie_consent')) {
    visible.value = true
  }
})

function acceptAll() {
  setCookie('cookie_consent', 'all', 365)
  visible.value = false
}

function acceptEssential() {
  setCookie('cookie_consent', 'essential', 365)
  visible.value = false
}

function setCookie(name, value, days) {
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/;SameSite=Lax`
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}
</script>
